module.exports = __webpack_public_path__ + "static/media/Landing_page_Banner_Tablet@2x.abd45d1c.webp";